import api from './api';

export interface ReferralTransaction {
  id: number;
  userId: number;
  provider: 'manual' | 'referral' | 'crypto';
  amount: string;
  currency: string;
  status: 'pending' | 'paid' | 'failed' | 'canceled';
  createdAt: string;
  paidAt?: string;
  failedAt?: string;
  canceledAt?: string;
  notes?: string;
  sourcePaymentId?: number;
}

export const fetchReferralTransactions = async (): Promise<ReferralTransaction[]> => {
  const response = await api.get<ReferralTransaction[]>('/payment/referral-transactions');
  return response.data;
};
